module.exports = __webpack_public_path__ + "img/banner2.149ec80e.jpg";